import axios from "axios";
import { toast } from "react-toastify";
var querystring = require("querystring");
// const BASE_URL = "http://43.204.210.192:3000/api/";
// const BASE_URL = "https://api.houzez.in:3000/api/";
const BASE_URL = "http://43.204.250.254:3000/api/";

export const postFormDataNoToken = async (url = "", data = {}) => {
  try {
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL + url, formData);

    return response.data;
  } catch (error) {
    // toast.error(error.message);
    // toast.error(error.response.data);
    return error.response.data;
  }
};
export const postFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post(BASE_URL + url, formData, {
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.message);
    // toast.error(error.response.data);
    return error.response.data;
  }
};
export const patchFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const formData = new URLSearchParams();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.patch(BASE_URL + url, formData, {
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.message);
    // toast.error(error.response.data);
    return error.response.data;
  }
};
export const postRawData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const response = await axios.post(BASE_URL + url, data, {
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.message);
    // toast.error(error.response.data);
    return error.response.data;
  }
};
export const postRawDataWithOutToken = async (url = "", data = {}) => {
  try {
    // const token = await localStorage.getItem("houzezToken");

    const response = await axios.post(BASE_URL + url, data, {
      headers: {},
    });

    return response.data;
  } catch (error) {
    // toast.error(error.message);
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const getDataNoToken = async (url = "", data = {}) => {
  try {
    const response = await axios.get(BASE_URL + url, {
      params: data,
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const getDataforUrl = async (url = "", data = "") => {
  try {
    const response = await axios.get(BASE_URL + url + `/${data}`);

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const getData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const response = await axios.get(BASE_URL + url, {
      params: data,
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const getDataStringify = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const response = await axios.get(BASE_URL + url, {
      params: data,

      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const postDataURLIncoded = async (url = "", data = {}) => {
  try {
    //const token = await localStorage.getItem("houzezToken");
    const formData = new URLSearchParams();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    //console.log(data);
    const response = await axios.post(
      BASE_URL + url,
      querystring.stringify(data),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    //console.log(response);
    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const postDataURLIncodedWithToken = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    const formData = new URLSearchParams();
    for (let key in data) {
      formData.append(key, data[key]);
    }

    const response = await axios.post(
      BASE_URL + url,
      querystring.stringify(data),
      {
        headers: {
          authtoken: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    //console.log(response);
    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const patchDataURLIncoded = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    const formData = new URLSearchParams();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    //console.log(data);
    const response = await axios.patch(
      BASE_URL + url,
      querystring.stringify(data),
      {
        headers: {
          authtoken: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    //console.log(response);
    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const putFormData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.put(BASE_URL + url, formData, {
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const putFormDataURLIncoded = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.put(
      BASE_URL + url,
      querystring.stringify(data),
      {
        headers: {
          authtoken: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const putRawData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const response = await axios.put(BASE_URL + url, data, {
      headers: {
        authtoken: token,
      },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const deleteData = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    const formData = new FormData();

    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.delete(BASE_URL + url, {
      headers: { authtoken: token },
      data: formData,
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const DeleteParams = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");

    const response = await axios.delete(BASE_URL + url, {
      params: data,
      headers: { authtoken: token },
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const deleteDataURLIncodedWithToken = async (url = "", data = {}) => {
  try {
    const token = await localStorage.getItem("houzezToken");
    // const formData = new FormData();

    // for (let key in data) {
    //   formData.append(key, data[key]);
    // }
    const response = await axios.delete(
      BASE_URL + url,

      {
        headers: {
          authtoken: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: querystring.stringify(data),
      }
    );

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};

export const getDataAndDownload = async (url = "", data = {}) => {
  try {
    //const token = await localStorage.getItem("houzezToken");

    const response = await axios({
      url: BASE_URL + url, //your url
      method: "GET",
      responseType: "blob", // important
      params: data,
    });

    return response.data;
  } catch (error) {
    // toast.error(error.response.data);
    return error.response.data;
  }
};
